import React from 'react';
import './index.scss';


//api
import { api } from '../../../functions/api';

//material ui
import { Grid, Paper } from '@material-ui/core';

//custom components
import CustomInput from '../../../components/basic/input';
// import CustomButton from '../../../components/basic/CustomButton';

//other libraries
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
// import Icon from '@mdi/react'
// import { mdiContentSaveOutline } from '@mdi/js'

const TIMEOUT = 500;

@inject('internal')
@inject('translate')
@observer
export default class SeoInfo extends React.Component {

    timeout = null;
    componentWillUnmount() {
        clearTimeout(this.timeout)
    }

    handleChange = () => {
        clearTimeout(this.timeout)
        this.timeout =  setTimeout(() => {
            this.updateData()
        }, TIMEOUT)
    }

    updateData = async () => {
        let seo_title = this.seo_title.state.value;

        let update_global_settings = await api({
            method:'post',
            url:'global-settings',
            authorization: this.props.internal.user.access_token,
            params: {
                seo_title: seo_title,

                //vyplname v predchadzajucich tabe
                // phone_primary: toJS(this.props.internal.dataForSimpeTable.phone_primary),
                // email_primary: toJS(this.props.internal.dataForSimpeTable.email_primary),
                // email_secondary: toJS(this.props.internal.dataForSimpeTable.email_secondary),
                // project_name: toJS(this.props.internal.dataForSimpeTable.project_name),
                // client_name: toJS(this.props.internal.dataForSimpeTable.client_name),
                // address: {
                //     street_name: toJS(this.props.internal.dataForSimpeTable.address.street_name),
                //     street_no: toJS(this.props.internal.dataForSimpeTable.address.street_no),
                //     city: toJS(this.props.internal.dataForSimpeTable.address.city),
                //     zip: toJS(this.props.internal.dataForSimpeTable.address.zip),
                //     country: toJS(this.props.internal.dataForSimpeTable.address.country),
                // },
                // id_no: toJS(this.props.internal.dataForSimpeTable.id_no),
                // id_vat: toJS(this.props.internal.dataForSimpeTable.id_vat),
                // id_tax: toJS(this.props.internal.dataForSimpeTable.id_tax),
            }
        })

        if(update_global_settings.success === true) {
            this.props.internal.setDataForSimpeTable(update_global_settings.data.data);
            this.props.internal.setSnackbar(update_global_settings.data.message, true)
        }
        else {
            let resultError = "";
            if(update_global_settings.data.data.errors) {
                for(let error in update_global_settings.data.data.errors){
                    resultError += update_global_settings.data.data.errors[error] + " "
                }
            }
            this.props.internal.setSnackbar(resultError, true)
        }
    }

    render() {
        return (
            <Paper className={'settings-basic'}>
            
                <Grid container spacing={16} >
                    {/* <Grid item xs={12} className={'save-btn'}>
                        <CustomButton
                            // progressBar={this.state.loading}
                            onClick={this.updateData}
                            mystyle={'btn-orange-bg border-radius-18'}
                            title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                        >
                            <Icon path={mdiContentSaveOutline} size={1}  />
                        </CustomButton>
                    </Grid> */}
                    <Grid item sm={12} md={6} lg={4} className={'settings-item'}>
                        <CustomInput
                            ref={ref => this.seo_title = ref}
                            text={this.props.translate.i18n.MODULES.SETTINGS.ADITIONAL_TITLE}
                            value={toJS(this.props.internal.dataForSimpeTable.seo_title)}
                            id={'seo_title'}
                            className={"w-100"}
                            change={this.handleChange}
                        />
                    </Grid>
                    
                </Grid>
                
            </Paper>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/settings/seo/index.js